import { render, staticRenderFns } from "./InsuranceAcceptanceModal.vue?vue&type=template&id=5c464652&scoped=true"
import script from "./InsuranceAcceptanceModal.vue?vue&type=script&lang=js"
export * from "./InsuranceAcceptanceModal.vue?vue&type=script&lang=js"
import style0 from "./InsuranceAcceptanceModal.vue?vue&type=style&index=0&id=5c464652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c464652",
  null
  
)

export default component.exports